<template>
  <el-form ref="ruleForm" :model="form" label-width="80">
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="支付途径">
          <el-radio-group v-model="form.payType">
            <el-radio :label="1" :value="1">线上支付</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="支付金额">
          <div class="pay_amount">￥{{ issueCost }}</div>
        </el-form-item>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <div class="qcBox">
        <div id="qcImg">
          <div id="qc" ref="qc"></div>
          <span>手机扫码进行支付</span>
        </div>
        
        <div id="qcText">
          <p>扫码支付后请选择下一步操作！</p>
          <ul>
            <li>扫码成功支付后系统无反应，请刷新支付状态 <el-button type="primary"  @click="refreshStatus"  :loading="rfsLoadding">刷新支付状态</el-button></li>
            <li>扫码后未完成支付，刷新二维码重新支付，<el-button type="warning" @click="refreshQc" :loading="rfqLoadding">刷新二维码</el-button></li>
            
          </ul>
          
        </div>
      </div>


    </el-row>
  </el-form>
</template>

<script>
//import settingApi from "@/api/setting"
import authorApi from "@/api/author";
import QRCode from "qrcodejs2";
export default {
  name: "FormPay",
  props: {
    articleId: {
      type: Number,
      require: true,
    },
    type: {
      type: Number,
      require: true,
    },

    //应收版面费
    issueCost: {
      type: Number,
      require: true,
    },
  },
  data() {
    return {
      form: {
        payType: 1,
      },
      orderId: 0,
      timers: null, //支付状态定时器
      qrcode: null,
      rfqLoadding: false,
      rfsLoadding: false,
    };
  },

  watch: {
    "form.payType": function (val) {
      if (val == 1) {//在线支付
        this.getQcURL();
      }
    },
  },
  created() {
    /**
     * 1. 定时器检测是否已经付款
     * 2. 检测是否付款成功
     */
    this.getQcURL();
  },

  destroyed() {
    clearInterval(this.timers);
  },

  methods: {
    //创建二维码
    createQc(data) {
      if (this.qrcode != null) {
        this.qrcode.clear();
      }
      this.qrcode = new QRCode(this.$refs.qc, {
        text: data.qc_url, // 需要转换为二维码的内容
        width: 150,
        height: 150,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H,
      });
    },

    //获取支付二维码URL
    getQcURL() {
      authorApi.getPayQcUrl(this.articleId).then((res) => {
        if (res.code == 0) {
          this.createQc(res.data);
          this.orderId = res.data.orderId;
          this.checkPayStatus();
        }
      });
    },

    //检测支付状态
    checkPayStatus() {
      let num = 0;
      this.timers = setInterval(() => {
        num++;
        authorApi.getPayResult(this.orderId).then((res) => {
          if (res.code == 0) {
            clearInterval(this.timers);
            this.$emit("paySuccess");
          }
        });

        if (num == 500) {
          clearInterval(this.timers);
        }
      }, 3000);
    },

    //刷新支付状态
    refreshStatus(){
      this.rfqLoadding = true;
      this.rfsLoadding = true;
      authorApi.refreshPayStatus(this.articleId).then((res) => {
        this.rfqLoadding = false;
        this.rfsLoadding = false;
        if (res.code == 0) {
          this.$alert('已经支付成功', "系统提示", {
            confirmButtonText: "确定",
            callback: () => {
              //更新父组件支付状态，0=尚未支付，1=已经支付
              this.$emit('payStatusChange', 1);
            },
          });
        } else {
          this.$alert(res.msg, "系统提示", {
            confirmButtonText: "确定",
            callback: () => {
            },
          });
        }
      });
    },

    //刷新二维码
    refreshQc() {
      this.rfqLoadding = true;
      this.rfsLoadding = true;
      authorApi.refreshPayQcUrl(this.articleId).then((res) => {
        this.rfqLoadding = false;
        this.rfsLoadding = false;
        if (res.code == 0) {
          if (res.data == 0) {//需要刷新二维码
            clearInterval(this.timers);
            this.$refs.qc.innerHTML = "";
            this.getQcURL();
          } else {//流程已经更新
            this.$alert('已经完成支付！！', "系统提示", {
              confirmButtonText: "确定",
              callback: () => {
                //更新父组件支付状态，0=尚未支付，1=已经支付
                this.$emit('payStatusChange', 1);
              },
            });
          }

        } else {
          this.$alert(res.msg, "系统提示", {
            confirmButtonText: "确定",
            callback: () => {
            },
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.pay_amount {
  color: #ff2200;
  font-size: 1.5rem;
}

.qcBox{
  display: flex;
  flex-direction: row;
}

#qcImg{
  width:190px;
  margin-right: 30px;
  span{
    display: block;
    text-align: center;
  }
}
#qc {
  margin: 20px;
  width: 150px;
  height: 150px;
  
}

#qc canvas {
  margin: auto;
}

#qcText {
  flex:1;
  p{
    margin-top: 20px;
    font-size: 16px;
  }
  ul{
    list-style-type: disc;
    padding-left: 25px;
    li{
      line-height: 30px;
  }
  }
  
}
</style>

